import { BaseApi } from "@/api/index";

const baseUrl = process.env.REACT_APP_BACKEND_URL || "";

export interface SearchSource {
  text: string;
  title: string;
  institution?: string | null;
  description?: string | null;
  case?: number;
  source: number;
  extracted_text: string | null;
}

export interface SearchResearchDocument {
  article: string;
  description: string;
  text: string;
  title: string;
  journal_name?: string | null;
  volume?: string | null;
  supplement_or_issue?: string | null;
  extracted_text: string | null;
  cases: number[];
}

export interface SearchParams {
  q?: string;
  case_id?: string;
  source_id?: string;
  limit?: number;
  offset?: number;
}

class SearchResearchDocumentApi<T = unknown> extends BaseApi<T> {
  constructor() {
    super({ apiBaseUrl: baseUrl, base: "search/research_documents" });
  }
}

class SearchSourceApi<T = unknown> extends BaseApi<T> {
  constructor() {
    super({ apiBaseUrl: baseUrl, base: "search/sources" });
  }
}

export const searchResearchDocumentsApi =
  new SearchResearchDocumentApi<SearchResearchDocument>();
export const searchSourcesApi = new SearchSourceApi<SearchSource>();
